import React from "react";
import { connect } from 'react-redux';
import { get as lodashGet } from 'lodash';
import lodashIsDate from 'lodash/isDate';

import SelectParcelForLastNitrogenInput from "../../components/lastNitrogenInput/selectParcelForLastNitrogenInput";
import DataGridSkeleton from "../../components/dataGridSkeleton.jsx";
import LastNitrogenInputStepsManagement from "../../components/lastNitrogenInput/lastNitrogenInputStepsManagement";
import LastNitrogenInputExternalStepsManagement from "../../components/lastNitrogenInput/lastNitrogenInputExternal/stepsManagement";

import { Alert, AlertTitle, Box } from "@mui/material";

import { ActionGetAllLastNitrogenInputs } from "../../redux/actions/lastNitrogenInput";

import DateHelper from '../../utils/dateHelper.js';
import ConstantsFertilizer from "../../utils/constantsFertilizer";

import StringTranslate from "../../assets/i18n/stringLanguage";


///////////////////////////////////////////////////////////////////////////
// Composant général concernant les derniers apports azotés (gestion et affichage).
///////////////////////////////////////////////////////////////////////////
class AbstractLastNitrogenInput extends React.Component {
    constructor(props) {
        super(props);

        const nowDate = new Date();
        this.defaultOpenDate = new Date(nowDate.getFullYear(), 0, 15); //janvier
        this.defaultCloseDate = new Date(nowDate.getFullYear(), 6, 15); //juillet

        this.engineProcessIsClose = false; //potentiellement revu par 'initializeDatas' !
        this.explainOpenDate = StringTranslate.textOpenDateAlertFertilizersWithoutDate; //potentiellement revu par 'initializeDatas' !

        this.initializeDatas();
    }

    componentDidMount() {
        const { getAllLastNitrogenInputs, lastNitrogenInputDicoIsLoaded, } = this.props;		
		//La liste des derniers apports sont chargés à cet endroit

		//Récupère les derniers apports, si pas déjà obtenu:
		if (lastNitrogenInputDicoIsLoaded === false) {
			getAllLastNitrogenInputs();
		}
    }

    componentDidUpdate(prevProps, prevState) {
        const { askingAzofertDatesRange } = this.props;

        //si on vient de recevoir les dates d'ouverture des service de fumure:
        if (((!prevProps) || (prevProps.askingAzofertDatesRange === true)) && (askingAzofertDatesRange === false)) {
            this.initializeDatas();
        }
    }

    initializeDatas() {
        const nowDate = new Date();
        const closingDateAzofert = lodashGet(this.props, 'closingDateAzofert', this.defaultCloseDate);
        const openingDateAzofert = lodashGet(this.props, 'openingDateAzofert', this.defaultOpenDate);

        this.engineProcessIsClose = (lodashIsDate(closingDateAzofert) && lodashIsDate(openingDateAzofert) &&
            (closingDateAzofert <= nowDate) && (openingDateAzofert >= nowDate) &&
            (closingDateAzofert < openingDateAzofert)) ? true : false;
        this.explainOpenDate = (lodashIsDate(openingDateAzofert)) ? 
            `${StringTranslate.textOpenDateAlertFertilizers} ${DateHelper.formati18n(openingDateAzofert, 'P')}` : 
            StringTranslate.textOpenDateAlertFertilizersWithoutDate;
    }

    /* fonction cycle de vie react */
    render() {
        const { newLastNitrogenInput, loading, addExternalInfos } = this.props;
        
        return(
            <>
                {
                    // Affiche un écran de chargement en attendant de récupérer les informations des derniers apports du client
                    (loading)?
                        <Box sx={{ width: '100%' }} >
                            <DataGridSkeleton/>
                        </Box>
                    :
                    // Affiche la séléction des parcelles pour lesquelles on peut lancer un dernier apport
                    (newLastNitrogenInput)?
                        ((this.engineProcessIsClose === true) ? 
                            <Alert severity="info">
                                <AlertTitle>{StringTranslate.titleInfoAlertFertilizers}</AlertTitle>
                                {StringTranslate.textUnavailableAlertLastNInput}
                                <strong>— {this.explainOpenDate}.</strong>
                                {StringTranslate.textGetPastAlertLastNInput}
                            </Alert>
                        :
                            ((addExternalInfos)?
                                <LastNitrogenInputExternalStepsManagement/>
                            :
                                <SelectParcelForLastNitrogenInput/>)
                        )
                    :
                    // Affiche le tableau des derniers apports existants
                        <LastNitrogenInputStepsManagement />//Steps ici
                }
            </>
        )
    }
}

/* fonction permettant de passer le state global (ou fraction) de l'application au composant HOComponent */
const mapStateToProps = state => ({
    //Infos provenant du reducer 'lastNitrogenInput' :
	lastNitrogenInputDicoIsLoaded: lodashGet(state, 'lastNitrogenInputData.lastNitrogenInputDicoIsLoaded', false),
    addExternalInfos: lodashGet(state, 'lastNitrogenInputData.addExternalInfos', false),
	loading: lodashGet(state, 'lastNitrogenInputData.loading', false),

    //Infos provenant du reducer 'fertilizer' :
    closingDateAzofert: lodashGet(state, 'fertilizerData.closingDateAzofert', ConstantsFertilizer.DefaultClosingDateAzofert),
    openingDateAzofert: lodashGet(state, 'fertilizerData.openingDateAzofert', ConstantsFertilizer.DefaultOpeningDateAzofert),
    askingAzofertDatesRange: lodashGet(state, 'fertilizerData.askingAzofertDatesRange', false),
});

/* fonction permettant de fournir les fonctions (actions) au composant */
const mapDispatchToProps = dispatch => ({
	getAllLastNitrogenInputs: () => dispatch( ActionGetAllLastNitrogenInputs() ),
});

export default connect(mapStateToProps, mapDispatchToProps)(AbstractLastNitrogenInput);